import { APP_COLORS } from "./colors";

export const autoCompleteStyles = `break-all break-words px-4 py-2 text-[${APP_COLORS.subtitleColor}]`;
